import React, { createContext } from 'react';

const UserPendingTransactionsContext = createContext();

export default UserPendingTransactionsContext;